import { render, staticRenderFns } from "./default-omn.vue?vue&type=template&id=c77ab190&scoped=true&"
import script from "./default-omn.vue?vue&type=script&lang=js&"
export * from "./default-omn.vue?vue&type=script&lang=js&"
import style0 from "./default-omn.vue?vue&type=style&index=0&lang=css&"
import style1 from "./default-omn.vue?vue&type=style&index=1&id=c77ab190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77ab190",
  null
  
)

export default component.exports